"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSdk = exports.GetNewBusinessVersionDocument = exports.GetVersionFromQuoteDocument = exports.GetVersionFromPolicyDocument = exports.GetVersionFromApplicationDocument = exports.GetPolicyTaxServiceFeeRateFromEffectiveDateAndLocationDocument = exports.GetPolicyTaxServiceFeeRateFromQuoteDocument = exports.GetPolicyTaxServiceFeeRateFromPolicyDocument = exports.GetPolicyTaxServiceFeeRateFromApplicationDocument = exports.WorkflowVersionFragmentDoc = exports.PolicyTaxServiceFeeRateFragmentDoc = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.PolicyTaxServiceFeeRateFragmentDoc = (0, graphql_tag_1.default) `
    fragment policyTaxServiceFeeRate on PolicyTaxServiceFeeRateData {
  id
  country
  provinceOrState
  taxRate
  serviceFeeRate
  surchargeRate
  implementationDate
  effectiveDate
  carrierPartner
  policyFeeRate
}
    `;
exports.WorkflowVersionFragmentDoc = (0, graphql_tag_1.default) `
    fragment workflowVersion on WorkflowVersionData {
  id
  effectiveDate
  implementationDate
  underwritingFrontendVersion
  underwritingBackendVersion
  quoteFrontendVersion
  quoteBackendVersion
  termsCondFrontendVersion
  termsCondBackendVersion
  paymentFrontendVersion
  paymentBackendVersion
  policyDocumentBackendVersion
  applicationJsonFileName
  applicationAnswerJsonFileNames
  configsVersion
  resourcesVersion
  timestamp
}
    `;
exports.GetPolicyTaxServiceFeeRateFromApplicationDocument = (0, graphql_tag_1.default) `
    query getPolicyTaxServiceFeeRateFromApplication($applicationObjectId: ID!) {
  getPolicyTaxServiceFeeRateFromApplication(
    applicationObjectId: $applicationObjectId
  ) {
    ...policyTaxServiceFeeRate
  }
}
    ${exports.PolicyTaxServiceFeeRateFragmentDoc}`;
exports.GetPolicyTaxServiceFeeRateFromPolicyDocument = (0, graphql_tag_1.default) `
    query getPolicyTaxServiceFeeRateFromPolicy($policyNumber: String!) {
  getPolicyTaxServiceFeeRateFromPolicy(policyNumber: $policyNumber) {
    ...policyTaxServiceFeeRate
  }
}
    ${exports.PolicyTaxServiceFeeRateFragmentDoc}`;
exports.GetPolicyTaxServiceFeeRateFromQuoteDocument = (0, graphql_tag_1.default) `
    query getPolicyTaxServiceFeeRateFromQuote($quoteObjectId: ID!) {
  getPolicyTaxServiceFeeRateFromQuote(quoteObjectId: $quoteObjectId) {
    ...policyTaxServiceFeeRate
  }
}
    ${exports.PolicyTaxServiceFeeRateFragmentDoc}`;
exports.GetPolicyTaxServiceFeeRateFromEffectiveDateAndLocationDocument = (0, graphql_tag_1.default) `
    query getPolicyTaxServiceFeeRateFromEffectiveDateAndLocation($policyEffectiveDate: String!, $transactionDate: String!, $country: String!, $provinceOrState: String!, $carrierPartner: String!) {
  getPolicyTaxServiceFeeRateFromEffectiveDateAndLocation(
    policyEffectiveDate: $policyEffectiveDate
    transactionDate: $transactionDate
    country: $country
    provinceOrState: $provinceOrState
    carrierPartner: $carrierPartner
  ) {
    ...policyTaxServiceFeeRate
  }
}
    ${exports.PolicyTaxServiceFeeRateFragmentDoc}`;
exports.GetVersionFromApplicationDocument = (0, graphql_tag_1.default) `
    query getVersionFromApplication($applicationObjectId: ID!) {
  getVersionFromApplication(applicationObjectId: $applicationObjectId) {
    ...workflowVersion
  }
}
    ${exports.WorkflowVersionFragmentDoc}`;
exports.GetVersionFromPolicyDocument = (0, graphql_tag_1.default) `
    query getVersionFromPolicy($policyNumber: String!) {
  getVersionFromPolicy(policyNumber: $policyNumber) {
    ...workflowVersion
  }
}
    ${exports.WorkflowVersionFragmentDoc}`;
exports.GetVersionFromQuoteDocument = (0, graphql_tag_1.default) `
    query getVersionFromQuote($quoteObjectId: ID!) {
  getVersionFromQuote(quoteObjectId: $quoteObjectId) {
    ...workflowVersion
  }
}
    ${exports.WorkflowVersionFragmentDoc}`;
exports.GetNewBusinessVersionDocument = (0, graphql_tag_1.default) `
    query getNewBusinessVersion($policyEffectiveDate: String!, $transactionDate: String!) {
  getNewBusinessVersion(
    policyEffectiveDate: $policyEffectiveDate
    transactionDate: $transactionDate
  ) {
    ...workflowVersion
  }
}
    ${exports.WorkflowVersionFragmentDoc}`;
const defaultWrapper = (action, _operationName, _operationType) => action();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        getPolicyTaxServiceFeeRateFromApplication(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPolicyTaxServiceFeeRateFromApplicationDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPolicyTaxServiceFeeRateFromApplication', 'query');
        },
        getPolicyTaxServiceFeeRateFromPolicy(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPolicyTaxServiceFeeRateFromPolicyDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPolicyTaxServiceFeeRateFromPolicy', 'query');
        },
        getPolicyTaxServiceFeeRateFromQuote(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPolicyTaxServiceFeeRateFromQuoteDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPolicyTaxServiceFeeRateFromQuote', 'query');
        },
        getPolicyTaxServiceFeeRateFromEffectiveDateAndLocation(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPolicyTaxServiceFeeRateFromEffectiveDateAndLocationDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPolicyTaxServiceFeeRateFromEffectiveDateAndLocation', 'query');
        },
        getVersionFromApplication(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetVersionFromApplicationDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getVersionFromApplication', 'query');
        },
        getVersionFromPolicy(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetVersionFromPolicyDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getVersionFromPolicy', 'query');
        },
        getVersionFromQuote(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetVersionFromQuoteDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getVersionFromQuote', 'query');
        },
        getNewBusinessVersion(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetNewBusinessVersionDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getNewBusinessVersion', 'query');
        }
    };
}
exports.getSdk = getSdk;
//# sourceMappingURL=version-controller.js.map